









































import vmFile from './BookComponentListItem.vue'

import { DemoFolder } from '../../classes/Main/DemoFolder'
import { ObjectHelpers } from 'asva-helpers'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faCaretDown,
  faCaretRight,
  faFolder,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'book-component-list-folder',
  components: {
    FontAwesomeIcon,
    vmFile,
  },
  props: {
    folder: {
      type: DemoFolder,
      required: true,
    },
  },
  methods: {
    openSelected (): void {
      const foldersChain = ObjectHelpers
        .traverseBranch(this.folder, { path: this.$route.path })
        .filter(item => {
          return (item instanceof DemoFolder)
        })

      if (foldersChain.length) {
        this.folder.isOpen = true
      }

      if (foldersChain.length > 1) {
        setTimeout(() => {
          const folderComponent = this.$refs.folders.find(
            (folderComponent: any) => folderComponent.folder === foldersChain[1],
          )
          folderComponent && folderComponent.openSelected()
        })
      }
    },
    generateKey (): number {
      return Math.floor(Math.random() * 1e8)
    },
  },
  computed: {
    icons (): { [name: string]: IconDefinition } {
      return {
        faFolder,
        faCaretDown,
        faCaretRight,
      }
    },
  },
}
